import React, { useMemo, useState } from 'react';
import StepShell from '../../onboarding/StepShell';

const COUNTRY_CODES = [
  { code: '+1', label: 'US +1' },
  { code: '+44', label: 'UK +44' },
  { code: '+91', label: 'IN +91' },
  { code: '+61', label: 'AU +61' },
];

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ResetRequestStep = ({ method, contact, setContact, onToggleMethod, onSubmit, onBack, error, submitting }) => {
  const [touched, setTouched] = useState(false);

  const isValid = useMemo(() => {
    if (method === 'email') {
      return EMAIL_RE.test(contact.email.trim());
    }
    return contact.phone.replace(/\D/g, '').length >= 7;
  }, [method, contact]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValid) return;
    onSubmit();
  };

  return (
    <StepShell
      step={1}
      totalSteps={3}
      title="Reset your password"
      subtitle={
        method === 'email'
          ? "Enter the email on your account and we'll send you a reset code"
          : "Enter the phone number on your account and we'll send you a reset code"
      }
      onBack={onBack}
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        {method === 'email' ? (
          <div className="ob-field">
            <input
              type="email"
              className="ob-input"
              placeholder="yourname@email.com"
              value={contact.email}
              onChange={(e) => setContact({ ...contact, email: e.target.value })}
              autoFocus
            />
          </div>
        ) : (
          <div className="ob-field ob-phone-row">
            <select
              className="ob-select"
              value={contact.countryCode}
              onChange={(e) => setContact({ ...contact, countryCode: e.target.value })}
            >
              {COUNTRY_CODES.map((c) => (
                <option key={c.code} value={c.code}>{c.label}</option>
              ))}
            </select>
            <input
              type="tel"
              className="ob-input"
              placeholder="000 000 0000"
              value={contact.phone}
              onChange={(e) => setContact({ ...contact, phone: e.target.value })}
              autoFocus
            />
          </div>
        )}

        {touched && !isValid && (
          <p className="ob-error-text">
            {method === 'email' ? 'Enter a valid email address.' : 'Enter a valid phone number.'}
          </p>
        )}
        {error && <p className="ob-error-text">{error}</p>}

        <div className="ob-spacer" />

        <button type="submit" className="ob-btn-primary" disabled={!isValid || submitting}>
          {submitting ? 'Sending…' : 'Send reset code'}
        </button>
        <button type="button" className="ob-link-muted" onClick={onToggleMethod}>
          Use {method === 'email' ? 'phone' : 'email'} instead
        </button>
      </form>
    </StepShell>
  );
};

export default ResetRequestStep;
